module.exports = __webpack_public_path__ + "static/img/img_intro_create.e66c317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_intro_create.png
// module id = CzbJ
// module chunks = 1